export default __webpack_public_path__ + "static/media/Profile_Neli_Speech.65a98163.png";